export enum ProfileStatusType {
  AwaitingInformation = 'AWAITING_INFORMATION',
  InformationCollectionInProgress = 'INFORMATION_COLLECTION_IN_PROGRESS',
  IdentityVerificationInProgress = 'IDENTITY_VERIFICATION_IN_PROGRESS',
  IdentityVerificationAbandoned = 'IDENTITY_VERIFICATION_ABANDONED',
  IdentityVerificationError = 'IDENTITY_VERIFICATION_ERROR',
  IdentityVerificationInError = 'IDENTITY_VERIFICATION_IN_ERROR',
  UnderAnalysis = 'UNDER_ANALYSIS',
  Accepted = 'ACCEPTED',
  Denied = 'DENIED',
  Rejected = 'REJECTED',
  CreationInProgress = 'CREATION_IN_PROGRESS'
}
